class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }

  constructor() {
    super();
    this.img = this.querySelector("img");
    this.observerCallback = (entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.unobserve(this);
        this.loadImage();
      }
    };
    this.loadImage = () => {
      this.setAttribute("intersecting", "true");
      this.img.sizes = `${this.clientWidth}px`;
      this.img.src = this.img.dataset.src;
    };
    this.img.onload = () => {
      this.removeAttribute("data-image-loading");
      this.img.classList.add("f-img-loaded");
    };
    if (this.img.complete) this.img.onload();
  }

  connectedCallback() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(this.observerCallback, { rootMargin: "10px" });
      this.observer.observe(this);
    } else {
      this.loadImage();
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

customElements.define("responsive-image", ResponsiveImage);
